<form [formGroup]="spiritualHistoryForm" >
    <div class="step-container">
      <ng-template #labelSeven>{{ getTranslation('otherPersonal.title') }}</ng-template>
      <div class="step-title">
        {{ isEditable ? getTranslation('otherPersonal.title') : getTranslation('otherPersonal.blockedForEdit') }}
        <span *ngIf="!isEditable" class="badge badge-warning ml-2" style="font-size: 0.75rem;">(Read Only)</span>
      </div>

      <div *ngIf="isJsonShow">
        {{spiritualHistoryForm.value | json}}

      </div>
 
  
      <div class="row gx-2">
        <!-- Have you ever been involved with any other spiritual organisations? -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-8 mb-0" [ngClass]="{'text-danger': spiritualHistoryForm.controls['IsInvolvedWithOtherSpiritual'].invalid && submitted}"
            >{{ getTranslation('otherPersonal.involvedOtherSpiritual') }} <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" class="form-check-input" formControlName="IsInvolvedWithOtherSpiritual" [value]="true" class="me-2"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" class="form-check-input" formControlName="IsInvolvedWithOtherSpiritual" [value]="false" class="me-2"> {{ getTranslation('common.no') }}</label>
  
              <br>
              <div *ngIf="submitted && spiritualHistoryForm.controls['IsInvolvedWithOtherSpiritual'].invalid" class="text-danger-val">
                {{ getTranslation('validation.involvedOtherSpiritualRequired') }}
              </div>
            </div>
          </div>
        </div>
  
        <div class="form-group col-12 mb-3" *ngIf="spiritualHistoryForm.get('IsInvolvedWithOtherSpiritual')?.value === true">
          <label for="OtherOrganisationDetails" class="form-label">{{ getTranslation('otherPersonal.whichOnesWhen') }}</label>
          <input type="text" class="form-control" id="OtherOrganisationDetails" formControlName="OtherOrganisationDetails" [placeholder]="getTranslation('otherPersonal.enterOrganisationDetails')" maxlength =150>
          <div *ngIf="submitted && spiritualHistoryForm.controls['OtherOrganisationDetails'].invalid" class="text-danger">
            {{ getTranslation('validation.otherOrganisationDetailsRequired') }}
          </div>
        </div>
  
        <!-- Have you ever been asked to leave a Siddha Yoga ashram or centre? -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-8 mb-0"   [ngClass]="{'text-danger': spiritualHistoryForm.controls['IsAskedToLeaveAshram'].invalid && submitted}"
            >{{ getTranslation('otherPersonal.askedToLeaveAshram') }} <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" class="form-check-input" formControlName="IsAskedToLeaveAshram" [value]="true" class="me-2"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" class="form-check-input" formControlName="IsAskedToLeaveAshram" [value]="false" class="me-2"> {{ getTranslation('common.no') }}</label>
  
              <br>
              <div *ngIf="submitted && spiritualHistoryForm.controls['IsAskedToLeaveAshram'].invalid" class="text-danger-val">
                {{ getTranslation('validation.askedToLeaveAshramRequired') }}
              </div>
            </div>
          </div>
        </div>
  
        <div class="form-group col-12 mb-3" *ngIf="spiritualHistoryForm.get('IsAskedToLeaveAshram')?.value === true">
          <label for="ReasonForAskToLeave" class="form-label">{{ getTranslation('otherPersonal.fromWhereWhenReason') }}</label>
          <!-- <input type="text" class="form-control" id="ReasonForAskToLeave" formControlName="ReasonForAskToLeave" placeholder="Enter Reason" maxlength =150> -->

          <textarea class="form-control" id="ReasonForAskToLeave" formControlName="ReasonForAskToLeave" [placeholder]="getTranslation('otherPersonal.enterReason')"  maxlength="500" rows="3" cols="50"></textarea>

          <div *ngIf="submitted && spiritualHistoryForm.controls['ReasonForAskToLeave'].invalid" class="text-danger">
            {{ getTranslation('validation.reasonForAskToLeaveRequired') }}
          </div>
        </div>
  
        <!-- Have you ever been convicted of a criminal offence besides a minor traffic violation? -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-8 mb-0"   [ngClass]="{'text-danger': spiritualHistoryForm.controls['IsHavingCriminalOffence'].invalid && submitted}"
            >{{ getTranslation('otherPersonal.criminalOffence') }} <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" class="form-check-input" formControlName="IsHavingCriminalOffence" [value]="true" class="me-2"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" class="form-check-input" formControlName="IsHavingCriminalOffence" [value]="false" class="me-2"> {{ getTranslation('common.no') }}</label>
  
              <br>
              <div *ngIf="submitted && spiritualHistoryForm.controls['IsHavingCriminalOffence'].invalid" class="text-danger-val">
                {{ getTranslation('validation.criminalOffenceRequired') }}
              </div>
            </div>
          </div>
        </div>
  
        <div class="form-group col-12 mb-3" *ngIf="spiritualHistoryForm.get('IsHavingCriminalOffence')?.value === true">
          <label for="OffenceDetails" class="form-label">{{ getTranslation('otherPersonal.pleaseDescribe') }}</label>
          <!-- <input type="text" class="form-control" id="OffenceDetails" formControlName="OffenceDetails" placeholder="Enter Details" maxlength =150> -->
        
          <textarea class="form-control" id="OffenceDetails" formControlName="OffenceDetails" [placeholder]="getTranslation('otherPersonal.enterDetails')"  maxlength="500" rows="3" cols="50"></textarea>


          <div *ngIf="submitted && spiritualHistoryForm.controls['OffenceDetails'].invalid" class="text-danger">
            {{ getTranslation('validation.offenceDetailsRequired') }}
          </div>

        </div>
  
        <!-- Have you had any history of illegal drug use and/or treatment in the last five years? -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-8 mb-0"   [ngClass]="{'text-danger': spiritualHistoryForm.controls['IsHavingDrugHistory'].invalid && submitted}"
            >{{ getTranslation('otherPersonal.drugHistory') }} <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" class="form-check-input" formControlName="IsHavingDrugHistory" [value]="true" class="me-2"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" class="form-check-input" formControlName="IsHavingDrugHistory" [value]="false" class="me-2"> {{ getTranslation('common.no') }}</label>
  
              <br>
              <div *ngIf="submitted && spiritualHistoryForm.controls['IsHavingDrugHistory'].invalid" class="text-danger-val">
                {{ getTranslation('validation.drugHistoryRequired') }}
              </div>
            </div>
          </div>
        </div>
  
        <div class="form-group col-12 mb-3" *ngIf="spiritualHistoryForm.get('IsHavingDrugHistory')?.value === true">
          <label for="DrugHistoryDetails" class="form-label">{{ getTranslation('otherPersonal.pleaseDescribe') }}</label>
          <!-- <input type="text" class="form-control" id="DrugHistoryDetails" formControlName="DrugHistoryDetails" placeholder="Enter Details" maxlength =150> -->
       
          <textarea class="form-control" id="DrugHistoryDetails" formControlName="DrugHistoryDetails" [placeholder]="getTranslation('otherPersonal.enterDetails')"  maxlength="500" rows="3" cols="50"></textarea>


          <div *ngIf="submitted && spiritualHistoryForm.controls['DrugHistoryDetails'].invalid" class="text-danger">
            {{ getTranslation('validation.drugHistoryDetailsRequired') }}
          </div>
       
        </div>
      </div>
  
    </div>
  <!-- Buttons start -->
  <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive" *ngIf="!isPreviewMode && isEditable" >
    <button type="button" class="btn savedraftbtn" 
            *ngIf="spiritualHistoryForm.get('SaveMode')?.value !== SaveMode.SAVE"
            (click)="onSubmit(SaveMode.DRAFT)">
      <i class="fas fa-save mr-2"></i>{{ getTranslation('button.saveAsDraft') }}
    </button>
    <button type="button" class="btn prevbtn" (click)="goToBack()">
      <i class="fas fa-arrow-left mr-2"></i>{{ getTranslation('button.previous') }}
    </button>
    <button type="button" class="btn nextbtn" (click)="onSubmit(SaveMode.SAVE)">
      <i class="fas fa-arrow-right mr-2"></i>{{ getTranslation('button.next') }}
    </button>
  </div>
   <!-- Buttons ends -->
  </form>
  